import api from "./axiosInstance";
import axios from "axios";

const buildApiPath = (path) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) {
    return path;
  }
  return `${baseUrl.replace(/\/$/, "")}${path}`;
};

export function submitCompanyApplication(payload) {
  return axios.post(buildApiPath("/company-applications/public"), payload);
}

export function fetchPendingCompanyApplications() {
  return api.get("/company-applications/pending");
}

export function approveCompanyApplication(applicationId, payload) {
  return api.post(`/company-applications/${applicationId}/approve`, payload);
}
